import React from 'react';
import { Navigation } from '../components/Navigation';
export function ThankYouPage() {
  return <div className="min-h-screen bg-[#0A2540] font-sans" data-id="element-189">
      <Navigation showButton={false} data-id="element-190" />

      {/* Accent line */}
      <div className="h-1 bg-[#0EA5E9]" data-id="element-191" />

      {/* Content */}
      <div className="flex items-center justify-center min-h-[calc(100vh-6rem)]" data-id="element-192">
        <div className="text-center px-4 max-w-2xl mx-auto" data-id="element-193">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-[#D4AF37] mb-6" style={{
          fontStyle: 'italic'
        }} data-id="element-194">
            Thank You!
          </h1>

          {/* Gold divider */}
          <div className="w-16 h-1 bg-[#D4AF37] mx-auto mb-8" data-id="element-195" />

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-196">
            Your request has been received.
          </h2>

          <p className="text-lg text-gray-400 leading-relaxed" data-id="element-197">
            One of our marine marketing specialists will be in touch with you
            shortly. We look forward to helping grow your dealership.
          </p>
        </div>
      </div>
    </div>;
}